import React from 'react'
import { connect } from 'react-redux'
import Hero from '../hero'
import Logo from '../logo'
import classnames from 'classnames'
import { getViewportHeight } from '../app/selectors'

const HeroFooter = ({ match, active, st, vh }) => (
  <div className={classnames({'hero__footer--active': active}, 'hero__footer')}>
    <div className="hero__footer-content">
      <Hero primary={false} active={match && match.isExact && (st < vh ) } />
      <Logo animate={false} active={true} />
    </div>
  </div>
)

const mapStateToProps = state => {
  return {
    active: state.footer.get('active'),
    vh: getViewportHeight(state),
    st: state["page_home"].get('st'),
  }
}

export default connect(mapStateToProps, null)(HeroFooter)


// WEBPACK FOOTER //
// ./src/components/main/hero-footer.js